export let feResultPageSensitiveParams = [
  'customer_mobile',
  'sender_mobile',
  'customer_name',
  'sender_name',
  'from_address_landmark',
  'from_address_lat',
  'from_address_long',
  'to_address_landmark',
  'to_address_lat',
  'to_address_long',
  'callback_request_id',
];
export let orderReviewPageSensitiveParams = [
  'from_landmark',
  'from_lat',
  'from_long',
  'from_house',
  'sender_name',
  'sender_mobile',
  'to_landmark',
  'to_lat',
  'to_long',
  'to_house',
  'receiver_name',
  'receiver_mobile',
];
export let feResultsParamsIdentifier = 'fe_params';
export let orderReviewParamsIdentifier = 'or_params';
